import { Injectable } from '@angular/core';

/**
 * PosConfigImagesService (Angular 18)
 *
 * Ported 1:1 from apps/b2b-ui/common/services/posConfig/posConfigImages/posConfigImages.service.js
 * (legacy name 'PosConfigImagesService'). Holds the POS splash-image model.
 * Internal sub-service of PosConfigService — injected directly, not
 * downgrade-registered. Dependency-free. Wave 3 #17.
 */
@Injectable({ providedIn: 'root' })
export class PosConfigImagesService {
  model: any = {
    displayTime: 5,
    images: [],
  };

  init(): boolean {
    return true;
  }

  setModel(model: any): void {
    this.model = model ? model : { displayTime: 5, images: [] };
  }

  getModel(): any {
    return this.model;
  }

  setImages(images: any): void {
    this.model.images = images;
  }

  getImages(): any {
    return this.model.images;
  }

  setDisplayTime(displayTime: any): void {
    this.model.displayTime = displayTime;
  }

  getDisplayTime(): any {
    return this.model.displayTime;
  }
}
